import React,{useState} from 'react';

const CALENDLY_URL='https://calendly.com/ajtaxconsulting';
let calendlyLoader;

const loadCalendly=()=>{
  if(window.Calendly)return Promise.resolve(window.Calendly);
  if(calendlyLoader)return calendlyLoader;
  calendlyLoader=new Promise((resolve,reject)=>{
    if(!document.querySelector('link[data-aj-calendly]')){
      const stylesheet=document.createElement('link');
      stylesheet.rel='stylesheet';
      stylesheet.href='https://assets.calendly.com/assets/external/widget.css';
      stylesheet.dataset.ajCalendly='true';
      document.head.appendChild(stylesheet);
    }
    const existing=document.querySelector('script[data-aj-calendly]');
    if(existing){existing.addEventListener('load',()=>resolve(window.Calendly),{once:true});existing.addEventListener('error',reject,{once:true});return;}
    const script=document.createElement('script');
    script.src='https://assets.calendly.com/assets/external/widget.js';
    script.async=true;
    script.dataset.ajCalendly='true';
    script.onload=()=>resolve(window.Calendly);
    script.onerror=reject;
    document.body.appendChild(script);
  });
  return calendlyLoader;
};

export const openCalendlyPopup=async()=>{
  try{
    const Calendly=await loadCalendly();
    if(!Calendly)throw new Error('Calendly unavailable');
    Calendly.initPopupWidget({url:CALENDLY_URL});
  }catch(error){window.open(CALENDLY_URL,'_blank','noopener,noreferrer');}
};

const CalendlyButton=({children,className='',onClick,...props})=>{
  const [loading,setLoading]=useState(false);
  const openScheduler=async event=>{
    onClick?.(event);
    if(event.defaultPrevented)return;
    setLoading(true);
    try{await openCalendlyPopup();}finally{setLoading(false);}
  };
  return <button type="button" onClick={openScheduler} className={className} aria-busy={loading||undefined} {...props}>{loading?'Opening calendar…':children}</button>;
};

export default CalendlyButton;
